<script setup lang="ts">
import type { Stats } from '../../atoms/AStats/types';
import { AHeading } from '@Atoms';

defineProps<{
  compact?: boolean;
  isDirectValue?: boolean;
  loading?: boolean;
  message?: string;
  severity?: string;
  stats?: Stats;
  subtitle?: string;
  title?: string;
}>();
</script>

<template>
  <div class="items-top flex flex-col justify-between gap-4 lg:flex-row">
    <div class="flex items-start gap-1">
      <AHeading
        v-if="title"
        :subtitle
        :title
      >
        <template #title>
          <slot name="title">{{ $t(title) }}</slot>
        </template>
      </AHeading>

      <Message
        v-if="message"
        class="!m-0"
        icon="p-0 w-0"
        pt:wrapper="p-1 pr-3 !min-h-8 text-sm"
        :closable="false"
        :severity
      >
        {{ message }}
      </Message>
    </div>

    <MStats
      v-if="stats"
      :compact
      :isDirectValue
      :loading
      :stats
    />
  </div>
</template>
